// @flow

import React from 'react';

import {
  type PaymentMethod,
  type PaymentMethodCode,
} from '../payment-method';

export const SelectedPaymentMethodContext = React.createContext<?[
  ?PaymentMethod,
  (PaymentMethodCode) => void,
    ]>(null);
